import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { acceptJson } from '../shared.js';
import { placePredictionsExtendedResponseSpec } from './specs.js';

const getPlacePredictionsExtended = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, request) {
        return validateResponse(placePredictionsExtendedResponseSpec, (yield fetch(`${apiUrl}/place/predictions/extended?name=${request.place}`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson)
        })));
    });
    return function getPlacePredictionsExtended(apiUrl, request) {
        return _ref.apply(this, arguments);
    };
}();

export { getPlacePredictionsExtended };
//# sourceMappingURL=place-predictions-extended.js.map
